"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var constants_1 = require("./constants");
// storage
var CookiesStorage_1 = __importDefault(require("./storage/CookiesStorage"));
// context
var context_1 = __importDefault(require("./context"));
var defaultStorage = new CookiesStorage_1.default();
var getDataFromStorage = function (storage) {
    if (storage === void 0) { storage = defaultStorage; }
    return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, storage.getItem(constants_1.SESSION_STORAGE_KEY)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); });
};
var sessionInstance = {
    session: undefined,
    user: undefined,
    authenticated: false,
    loadDataFromStorage: getDataFromStorage,
    saveSession: function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            throw new Error('Save session method was called when <Session /> is not present in the React DOM');
        });
    }); },
    removeSession: function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            throw new Error('Remove session method was called when <Session /> is not present in the React DOM');
        });
    }); },
    saveUser: function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            throw new Error('Save user method was called when <Session /> is not present in the React DOM');
        });
    }); }
};
var Session = function (_a) {
    var children = _a.children, initialData = _a.initialData, _b = _a.storage, storage = _b === void 0 ? defaultStorage : _b;
    var getInitialData = function () {
        if (!initialData) {
            return {};
        }
        return __assign({}, initialData);
    };
    var _c = react_1.useState(getInitialData()), data = _c[0], setData = _c[1];
    var _d = react_1.useState(!!initialData && !!initialData.session), authenticated = _d[0], setAuthenticated = _d[1];
    var _e = react_1.useState(!!initialData), checked = _e[0], setChecked = _e[1];
    var loadDataFromStorage = function () {
        return getDataFromStorage(storage);
    };
    var init = function () { return __awaiter(_this, void 0, void 0, function () {
        var data_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!initialData) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadDataFromStorage()];
                case 1:
                    data_1 = _a.sent();
                    if (data_1) {
                        setData(__assign({}, data_1));
                    }
                    setAuthenticated(!!data_1);
                    _a.label = 2;
                case 2:
                    setChecked(true);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        init();
    }, []);
    var saveSession = function (session) { return __awaiter(_this, void 0, void 0, function () {
        var newData;
        return __generator(this, function (_a) {
            newData = __assign({}, data, { session: session });
            // save session in the storage
            storage.setItem(constants_1.SESSION_STORAGE_KEY, newData);
            // save session in component's state
            setData(newData);
            setAuthenticated(true);
            return [2 /*return*/];
        });
    }); };
    var removeSession = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // remove session from the storage
            storage.removeItem(constants_1.SESSION_STORAGE_KEY);
            // remove session from the state
            setAuthenticated(false);
            setData({});
            return [2 /*return*/];
        });
    }); };
    var saveUser = function (user) { return __awaiter(_this, void 0, void 0, function () {
        var newData;
        return __generator(this, function (_a) {
            newData = __assign({}, data, { user: user });
            // save user in the storage
            storage.setItem(constants_1.SESSION_STORAGE_KEY, newData);
            // save user in component's state
            setData(newData);
            return [2 /*return*/];
        });
    }); };
    // update instance
    sessionInstance = {
        session: data.session,
        user: data.user,
        saveSession: saveSession,
        removeSession: removeSession,
        saveUser: saveUser,
        authenticated: authenticated,
        loadDataFromStorage: loadDataFromStorage
    };
    if (!checked) {
        return null;
    }
    return (react_1.default.createElement(context_1.default.Provider, { value: sessionInstance }, children));
};
exports.default = Session;
// expose methods
exports.getSession = function () { return sessionInstance.session; };
exports.getUser = function () { return sessionInstance.user; };
exports.getAuthenticated = function () { return sessionInstance.authenticated; };
exports.loadDataFromStorage = function () { return sessionInstance.loadDataFromStorage; };
exports.saveSession = function (session) {
    return sessionInstance.saveSession(session);
};
exports.removeSession = function () {
    return sessionInstance.removeSession();
};
exports.saveUser = function (user) {
    return sessionInstance.saveUser(user);
};
exports.useSession = function () { return react_1.useContext(context_1.default); };
//# sourceMappingURL=index.js.map